var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTowing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.916992 12.5827V8.91602H8.43366L2.75033 4.42435V7.08268H0.916992V1.58268H1.83366L11.917 7.12852V0.666016H16.5003L21.0837 6.16602V12.5827H18.792C18.792 13.3466 18.5246 13.9959 17.9899 14.5306C17.4552 15.0653 16.8059 15.3327 16.042 15.3327C15.2781 15.3327 14.6288 15.0653 14.0941 14.5306C13.5594 13.9959 13.292 13.3466 13.292 12.5827H8.25033C8.25033 13.3466 7.98296 13.9959 7.44824 14.5306C6.91352 15.0653 6.26421 15.3327 5.50033 15.3327C4.73644 15.3327 4.08713 15.0653 3.55241 14.5306C3.01769 13.9959 2.75033 13.3466 2.75033 12.5827H0.916992ZM5.50033 13.9577C5.89755 13.9577 6.22602 13.8278 6.48574 13.5681C6.74546 13.3084 6.87533 12.9799 6.87533 12.5827C6.87533 12.1855 6.74546 11.857 6.48574 11.5973C6.22602 11.3375 5.89755 11.2077 5.50033 11.2077C5.1031 11.2077 4.77463 11.3375 4.51491 11.5973C4.25519 11.857 4.12533 12.1855 4.12533 12.5827C4.12533 12.9799 4.25519 13.3084 4.51491 13.5681C4.77463 13.8278 5.1031 13.9577 5.50033 13.9577ZM16.042 13.9577C16.4392 13.9577 16.7677 13.8278 17.0274 13.5681C17.2871 13.3084 17.417 12.9799 17.417 12.5827C17.417 12.1855 17.2871 11.857 17.0274 11.5973C16.7677 11.3375 16.4392 11.2077 16.042 11.2077C15.6448 11.2077 15.3163 11.3375 15.0566 11.5973C14.7969 11.857 14.667 12.1855 14.667 12.5827C14.667 12.9799 14.7969 13.3084 15.0566 13.5681C15.3163 13.8278 15.6448 13.9577 16.042 13.9577ZM13.7503 6.16602H18.7003L15.6295 2.49935H13.7503V6.16602Z",
    fill: "url(#paint0_linear_4847_63938)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4847_63938",
    x1: 0.916992,
    y1: 0.666016,
    x2: 21.4869,
    y2: 1.25519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE594"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowing);
export default __webpack_public_path__ + "static/media/towing.5ab1c8a2cd1cbef37d0f9fd642d5a67a.svg";
export { ForwardRef as ReactComponent };